export default __webpack_public_path__ + "static/media/330_business02-jp-mobile.3fc451b3.png";